import React from 'react'
import MaterialSymbol from '../material-symbol'

const NavigateBefore = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="navigate_before" {...props} />
))

NavigateBefore.displayName = 'NavigateBefore'

export default NavigateBefore
